import React from 'react';
import styled from 'styled-components';

const ChartIcon = styled.div`
  position: absolute;
  top: 0;
  left: 30px;
  font-size: 24px;
  color: ${props => props.color};
`;

export default ChartIcon;
